import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { t } from '../../services/i18nService';
import modalUtils from '../../qti/utils/ModalUtils';
import styles from './DrawingDeleteConfirmModal.scss';

const DrawingDeleteConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
}) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            style={modalUtils.confirmationModalStyles}
            tabIndex="0"
            ariaHideApp={false}
        >
            <div className={styles.modalWrapper}>
                <div className={styles.headerContainer}>
                    <div className={styles.header}>
                        <h2 className={styles.modalTitle}>
                            {t('interactions.drawing.deleteConfirmModal.title')}
                        </h2>
                    </div>
                    <div className={styles.toolbar}>
                        <button
                            className={styles.closeButton}
                            onClick={handleClose}
                        >
                            <span className="sr-only">{t('general.close')}</span>
                            <i className="fa fa-times" aria-hidden="true" />
                        </button>
                    </div>
                </div>

                <div className={styles.modalContent}>
                    <p className={styles.modalDescription}>
                        {t('interactions.drawing.deleteConfirmModal.description')}
                    </p>
                </div>

                <div className={styles.modalFooter}>
                    <button
                        onClick={handleConfirm}
                        className={styles.deleteButton}
                    >
                        {t('interactions.drawing.deleteConfirmModal.delete')}
                    </button>
                    <button
                        onClick={handleClose}
                        className={styles.cancelButton}
                    >
                        {t('interactions.drawing.deleteConfirmModal.cancel')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

DrawingDeleteConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default DrawingDeleteConfirmModal;
